//Use when headers depends on channelType
const getColumns = (headers = [], channelType) => {
	const columns = [];

	headers?.map((header) => {
		if (header.children?.length === 0) {
			columns.push(header);
		} else {
			{
				header.children?.map((item) => {
					if (item.visibleIn?.includes(channelType)) {
						columns.push(item);
					}
				});
			}
		}
		return true;
	});
	return columns;
};

export { getColumns };
n